export default __webpack_public_path__ + "static/media/telegram.8b982959.svg";